import { combineEpics, ofType } from "redux-observable";
import { of, from, Observable, mergeMap, catchError } from "rxjs";
import { AnyAction } from "redux";
import { RootStateOrAny } from "react-redux";
import { errorString } from "../../utils/strings";
import { data as constants } from "../../constants";
import { fetchInterviewersUsecase } from "../../core/usecases/interactors/interviewer";
import { FETCH_INTERVIEWERS_REQUEST } from "./actionTypes";
import { fetchInterviewersFailure, fetchInterviewersSuccess } from "./actions";

export const fetchInterviewersEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  {
    interviewerInteractor: { fetchInterviewers },
  }: { interviewerInteractor: { fetchInterviewers: fetchInterviewersUsecase } }
) =>
  action$.pipe(
    ofType(FETCH_INTERVIEWERS_REQUEST),
    mergeMap(() => {
      return from(fetchInterviewers()).pipe(
        mergeMap((response) => {
          return of(fetchInterviewersSuccess(response));
        }),
        catchError((error) => {
          const errorMessage = errorString(error);
          errorMessage.includes(constants.commonNetworkError) &&
            window.location.reload();
          return of(fetchInterviewersFailure(errorMessage));
        })
      );
    })
  );

//@ts-ignore
export default combineEpics(fetchInterviewersEpic);
